var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRainmakerSoftIcon49TileView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    viewBox: "0 0 33.1 33.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18H6.3c-1.1 0-2 .9-2 2v7.4c0 1.1.9 2 2 2h7.2c1.1 0 2-.9 2-2V20c0-1.1-.9-2-2-2zm.5 9.3c0 .3-.2.5-.5.5H6.3c-.3 0-.5-.2-.5-.5V20c0-.3.2-.5.5-.5h7.2c.3 0 .5.2.5.5v7.3zm-.5-22.9H6.3c-1.1 0-2 .9-2 2v7.4c0 1.1.9 2 2 2h7.2c1.1 0 2-.9 2-2V6.4c0-1.1-.9-2-2-2zm.5 9.4c0 .3-.2.5-.5.5H6.3c-.3 0-.5-.2-.5-.5V6.4c0-.3.2-.5.5-.5h7.2c.3 0 .5.2.5.5v7.4zM26.9 18h-7.2c-1.1 0-2 .9-2 2v7.4c0 1.1.9 2 2 2h7.2c1.1 0 2-.9 2-2V20c0-1.1-.9-2-2-2zm.5 9.3c0 .3-.2.5-.5.5h-7.2c-.3 0-.5-.2-.5-.5V20c0-.3.2-.5.5-.5h7.2c.3 0 .5.2.5.5v7.3zm-.5-22.9h-7.2c-1.1 0-2 .9-2 2v7.4c0 1.1.9 2 2 2h7.2c1.1 0 2-.9 2-2V6.4c0-1.1-.9-2-2-2zm.5 9.4c0 .3-.2.5-.5.5h-7.2c-.3 0-.5-.2-.5-.5V6.4c0-.3.2-.5.5-.5h7.2c.3 0 .5.2.5.5v7.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainmakerSoftIcon49TileView);
export default __webpack_public_path__ + "static/media/Rainmaker_soft_icon_49_TileView.1d2d99c5.svg";
export { ForwardRef as ReactComponent };